(function ($) {
  "use strict";

  if (typeof localize === "undefined") {
    return;
  }

  var flatIds = localize.discountedApartmentsFlatIds || [];
  if (!flatIds.length) {
    return;
  }

  var translations = localize.translations || {};

  function formatFloor(floor) {
    if (floor === null || floor === undefined || floor === "") {
      return "";
    }
    if (String(floor) === "0" || String(floor).toLowerCase() === "földszint") {
      return translations.groundFloor || "Földszint";
    }
    return floor + ". " + (translations.floor || "Emelet");
  }

  function formatRooms(rooms) {
    if (rooms === null || rooms === undefined || rooms === "") {
      return "";
    }
    return rooms + " " + (translations.room || "szoba");
  }

  function formatPrice(price, currency) {
    if (price === null || price === undefined || price === "") {
      return "";
    }
    var num = parseInt(price, 10);
    if (isNaN(num)) {
      return String(price);
    }
    if (currency === "EUR") {
      return num.toLocaleString("en-US") + " EUR";
    }
    return num.toString().replace(/\B(?!\.\d*)(?=(\d{3})+(?!\d))/g, ".") + " Ft";
  }

  function formatArea(area) {
    if (!area) {
      return "";
    }
    return area + " m<sup>2</sup>";
  }

  function formatTerrace(terrace) {
    if (!terrace || parseFloat(String(terrace).replace(",", ".")) === 0) {
      return "";
    }
    return terrace + " m<sup>2</sup>&nbsp; " + (translations.terrace || "Terasz").toLowerCase();
  }

  function toggleField($el, hasContent) {
    var $row = $el.closest(".discounted-apartment-card__row");
    var $target = $row.length && !$row.hasClass("discounted-apartment-card__row--split") ? $row : $el;
    $target.toggle(!!hasContent);
  }

  function fillTextField($card, field, text) {
    var $el = $card.find('[data-field="' + field + '"]');
    if (!$el.length) {
      return;
    }
    $el.text(text);
    toggleField($el, text);
  }

  function fillHtmlField($card, field, html) {
    var $el = $card.find('[data-field="' + field + '"]');
    if (!$el.length) {
      return;
    }
    $el.html(html);
    toggleField($el, html);
  }

  function updateDetailUrl($card, projectId) {
    var $link = $card.find('[data-field="detail-url"]');
    if (!$link.length || !projectId) {
      return;
    }

    var residential = localize.residentials ? localize.residentials[projectId] : null;

    if (!residential || !residential.link) {
      return;
    }

    var flatCode = $link.attr("data-flat-code") || "";
    $link.attr("href", residential.link + flatCode);
  }

  function fillCard($card, data) {
    if (!data) {
      return;
    }

    fillHtmlField($card, "area", formatArea(data.area));
    fillTextField($card, "floor", formatFloor(data.floor));
    fillHtmlField($card, "terrace", formatTerrace(data.terrace));
    fillTextField($card, "rooms", formatRooms(data.rooms));
    fillTextField($card, "price", formatPrice(data.price, data.currency));
    updateDetailUrl($card, data.project_id);
  }

  $(function () {
    $.ajax({
      url: localize.ajaxurl,
      method: "POST",
      dataType: "json",
      data: {
        action: "discounted_apartments_card_data",
        flat_ids: flatIds,
      },
    }).done(function (response) {
      if (!response || !response.success || !response.data || !response.data.flats) {
        $(".discounted-apartment-card").addClass("is-ready");
        return;
      }

      var flats = response.data.flats;
      var sliderEl = document.querySelector(".js-discounted-apartments-slider");
      var swiper = sliderEl ? sliderEl.swiper : null;
      var $realSlides = $(".js-discounted-apartments-slider .swiper-slide:not(.swiper-slide-duplicate)");
      var slideIndexesToRemove = [];

      $(".discounted-apartment-card").each(function () {
        var $card = $(this);
        var flatId = $card.data("flat-id");

        if (flatId && flats[flatId]) {
          fillCard($card, flats[flatId]);
          $card.addClass("is-ready");
          return;
        }

        var $slide = $card.closest(".swiper-slide");
        if (!$slide.length) {
          $card.remove();
          return;
        }

        if (swiper) {
          var slideIndex = $realSlides.index($slide);
          if (slideIndex > -1 && slideIndexesToRemove.indexOf(slideIndex) === -1) {
            slideIndexesToRemove.push(slideIndex);
          }
        } else {
          $slide.remove();
        }
      });

      if (swiper && slideIndexesToRemove.length) {
        swiper.removeSlide(slideIndexesToRemove);
      }

      if (!$(".discounted-apartment-card").length) {
        if (swiper) {
          swiper.destroy(true, true);
        }
        $(".section__discounted-apartments").remove();
      }
    }).fail(function () {
      $(".discounted-apartment-card").addClass("is-ready");
    });
  });
})(jQuery);
